import React from 'react';
import ULItemLayout from '../content/ULItemLayout';
import Typography from './Typography';
const ULItem = ({ style, ...typographyProps }) => {
    return (React.createElement(ULItemLayout, { style: style },
        React.createElement(Typography, { flex: true, ...typographyProps })));
};
export default ULItem;
